<div class="container" dataqsi="schedule">
    <div class="title">
        {{"bloc-delivery-informations.openingDays" | translate}}
        <!-- {{refDeliveryinformation.startingPeriod}} {{"bloc-delivery-informations.to" | translate}}
        {{refDeliveryinformation.startingPeriod}} -->
    </div>
    <div class="openingDays">
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.monday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.monday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.monday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.tuesday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.tuesday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.tuesday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.wednesday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.wednesday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.wednesday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.thursday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.thursday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.thursday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.friday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.friday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.friday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.saturday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.saturday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.saturday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
        <div class="oneDay">
            <div class="day_container">
                <div class="day">{{"bloc-delivery-informations.sunday" | translate}}</div>
            </div>
            <div class="oneDayHours">
                <div class="hours" *ngFor="let hour of refDeliveryinformation.sunday;">{{formatingHours(hour)}} </div>
                <div class="hours" *ngIf="!refDeliveryinformation.sunday">{{"bloc-delivery-informations.closed" |translate}} </div>
            </div>
        </div>
    </div>
</div>
